import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PropTypes from 'prop-types';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import Text from '@zenbusiness/zui/Text';

import { CLICKSTREAM_COMMON_PROPS } from '#client/components/utils/constants';

import * as Styled from './NameCard.style';

/**
 * Individual item card component
 * @param {object} props - Component props
 * @param {object} props.item - Item data
 * @param {boolean} [props.selected=false] - Whether this item is selected
 * @param {Function} props.onClick - Click handler for item selection
 */
function NameCard({ item, selected = false, onClick }) {
  const displayTitle = item.title;

  const handleLinkPressed = useClickstreamCallback('linkPressed', {
    ...CLICKSTREAM_COMMON_PROPS,
    elementName: 'business_name_select',
    elementText: displayTitle
  });

  const handleClick = () => {
    if (onClick) {
      handleLinkPressed();
      onClick(displayTitle);
    }
  };

  return (
    <Styled.NameCardRoot
      aria-pressed={selected}
      role="button"
      selected={selected}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <Text selected={selected} size="sm" weight="medium">
        {displayTitle}
      </Text>
      <KeyboardArrowRightIcon fontSize="small" />
    </Styled.NameCardRoot>
  );
}

NameCard.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    reason: PropTypes.string
  }).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};

export default NameCard;
